// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobilesupervisorloader-container{min-height:5rem}.mobilesupervisorloader-container .loader{font-size:small}
`, "",{"version":3,"sources":["webpack://./src/components/shared/MSStatusWrappers/MSLoadingStatus.scss"],"names":[],"mappings":"AAAA,kCACE,eAAgB,CADlB,0CAGI,eAAgB","sourcesContent":[".mobilesupervisorloader-container {\n  min-height: 5rem;\n  .loader {\n    font-size: small;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
